
import { useState } from "react";
import { RequirePassword } from "@/components/auth/RequirePassword";
import { Session } from "@supabase/supabase-js";

interface PasswordPromptHandlerProps {
  session: Session | null;
  isNewUser: boolean;
  children: React.ReactNode;
}

export const PasswordPromptHandler = ({ 
  session, 
  isNewUser, 
  children 
}: PasswordPromptHandlerProps) => {
  const [hasSetPassword, setHasSetPassword] = useState(false);

  // If the user is new (from a magic link) and hasn't set a password yet,
  // show the password creation screen first
  if (isNewUser && !hasSetPassword) {
    return (
      <RequirePassword 
        email={session?.user?.email} 
        onComplete={() => setHasSetPassword(true)}
      />
    );
  }

  // If password is set or not needed, render children
  return <>{children}</>;
};
